import { Link } from 'react-router-dom';

export default function PricingHero() {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h1 className="font-sora font-bold text-6xl text-charcoal mb-6">
          Simple, Transparent Packages
        </h1>
        <p className="font-inter text-xl text-gray-600 leading-relaxed mb-4">
          Built for local businesses that want a premium online presence and real results.
        </p>
        <p className="font-inter text-lg text-gray-500 mb-8">
          Most projects start at $1,500. Ongoing maintenance is available to keep your site secure, fast, and up to date.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-block bg-primary text-white px-8 py-4 rounded-xl font-inter font-medium text-base hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a Call
          </Link>
          <Link
            to="/contact"
            className="inline-block bg-white text-charcoal border-2 border-charcoal px-8 py-4 rounded-xl font-inter font-medium text-base hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </section>
  );
}